var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-42cc56cd"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "bg-white dark:bg-gray-900" };
var _hoisted_2 = { class: "py-8 px-4 mx-auto max-w-2xl lg:py-16" };
var _hoisted_3 = { action: "#" };
var _hoisted_4 = { class: "grid gap-4 sm:grid-cols-2 sm:gap-6" };
var _hoisted_5 = { class: "sm:col-span-2" };
var _hoisted_6 = {
    for: "name",
    class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_7 = {
    role: "status",
    style: { "display": "inline-block", "margin-left": "2%" }
};
var _hoisted_8 = ["aria-hidden"];
var _hoisted_9 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("path", {
    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
    fill: "currentColor"
}, null, -1); });
var _hoisted_10 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("path", {
    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
    fill: "currentFill"
}, null, -1); });
var _hoisted_11 = [
    _hoisted_9,
    _hoisted_10
];
var _hoisted_12 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "sr-only" }, "Loading...", -1); });
var _hoisted_13 = { class: "relative" };
var _hoisted_14 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        "aria-hidden": "true",
        class: "w-5 h-5 text-gray-500 dark:text-gray-400",
        fill: "currentColor",
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg",
        id: "search"
    }, [
        /*#__PURE__*/ _createElementVNode("path", { d: "M448.3 424.7L335 311.3c20.8-26 33.3-59.1 33.3-95.1 0-84.1-68.1-152.2-152-152.2-84 0-152 68.2-152 152.2s68.1 152.2 152 152.2c36.2 0 69.4-12.7 95.5-33.8L425 448l23.3-23.3zM120.1 312.6c-25.7-25.7-39.8-59.9-39.8-96.3s14.2-70.6 39.8-96.3 59.9-40 96.2-40c36.3 0 70.5 14.2 96.2 39.9s39.8 59.9 39.8 96.3-14.2 70.6-39.8 96.3c-25.7 25.7-59.9 39.9-96.2 39.9-36.3.1-70.5-14.1-96.2-39.8z" })
    ])
], -1); });
var _hoisted_15 = ["placeholder"];
var _hoisted_16 = ["selected", "value"];
var _hoisted_17 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_18 = { class: "w-full" };
var _hoisted_19 = {
    for: "data",
    class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_20 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_21 = { class: "w-full" };
var _hoisted_22 = {
    for: "reazioni",
    class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_23 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_24 = { class: "w-full" };
var _hoisted_25 = {
    for: "richiamo",
    class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_26 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("option", { value: "1" }, "1° richiamo", -1); });
var _hoisted_27 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("option", { value: "2" }, "2° richiamo", -1); });
var _hoisted_28 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("option", { value: "3" }, "3° richiamo", -1); });
var _hoisted_29 = [
    _hoisted_26,
    _hoisted_27,
    _hoisted_28
];
var _hoisted_30 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_31 = {
    style: { "margin-top": "2%" },
    class: "w-full"
};
var _hoisted_32 = {
    key: 0,
    for: "confidenzialità",
    class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_33 = ["value"];
var _hoisted_34 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_35 = { class: "flex justify-between" };
import { onMounted, reactive } from "vue";
import { ref } from "vue";
import { initFlowbite } from "flowbite";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { Modal } from "flowbite-vue";
import { filterFarmaciVaccini } from "@/../../EshJSLib/services/farmaciServices";
import vaccinazioniModalHeader from "./vaccinazioniModalHeader.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'vecciniEditCreate',
    emits: ["cancel"],
    setup: function (__props, _a) {
        var __expose = _a.expose, emit = _a.emit;
        var alertModal = ref(null);
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var vaccininew = ref({});
        var alertConfirmMessage = ref(null);
        var showConfirm = ref(false);
        var resolvePromise;
        var isOpen = ref(false);
        var mandatoryFields = ['id_vaccino', 'vaccinazione_data', 'vaccinazione_reazioni', 'vaccinazione_richiamo', 'id_livello_confidenzialita'];
        var errors = ref([]);
        var errorMessage = "Questo campo è obbligatorio!";
        var filteredVaccinis = {};
        var selectedarmaco = {};
        var filteredVaccinisReact = reactive(filteredVaccinis);
        var selectedFarmaciReact = reactive(selectedarmaco);
        var selectedId = ref(0);
        var vacciniSearch = "";
        var farmacoSrc = ref(false);
        var pazienteModalTitle = ref('');
        onMounted(function () {
            errors.value = [];
            initFlowbite();
        });
        function openModal(message, rowData, title) {
            errors.value = [];
            vaccininew.value = rowData;
            alertConfirmMessage.value = message;
            pazienteModalTitle.value = title;
            vacciniSearch = "";
            showConfirm.value = true;
            return new Promise(function (resolve) {
                resolvePromise = resolve;
            });
        }
        function filtername() {
            farmacoSrc.value = true;
            filteredVaccinis = {};
            if (vacciniSearch.length < 3)
                return;
            var res = filterFarmaciVaccini(vacciniSearch);
            res.then(function (value) {
                filteredVaccinisReact.Farmaci = value;
                isOpen.value = true;
                farmacoSrc.value = false;
                errors.value[0] = value.length > 0 ? '' : 'Nessun risultato trovato !';
            });
        }
        function onVaccineChange(e) {
            var _a, _b;
            console.log(e.target.value);
            isOpen.value = false;
            if (e.target == null) {
                return;
            }
            var id = e.target.value;
            var name = e.target.options[e.target.options.selectedIndex].text;
            vacciniSearch = name;
            selectedarmaco =
                (_b = (_a = filteredVaccinisReact === null || filteredVaccinisReact === void 0 ? void 0 : filteredVaccinisReact.Farmaci) === null || _a === void 0 ? void 0 : _a.at(e.target.options.selectedIndex)) !== null && _b !== void 0 ? _b : null;
        }
        function saveVaccini() {
            if (!validateFields()) {
                return;
            }
            alertModal.value.openModal("Sei sicuro di salvare i dati?", true).then(function (userInput) {
                console.log('working ?');
                if (userInput) {
                    showConfirm.value = false;
                    if (!resolvePromise)
                        return;
                    resolvePromise(true);
                }
            });
        }
        function validateFields() {
            var hasError = false;
            errors.value = [];
            mandatoryFields.forEach(function (field, index) {
                if (!vaccininew.value[field]) {
                    console.log(field);
                    console.log(errors);
                    hasError = true;
                    errors.value.push(errorMessage);
                }
                else {
                    errors.value.push("");
                }
            });
            if (hasError) {
                return false;
            }
            return true;
        }
        function validateDate() {
            if (new Date(vaccininew.value.vaccinazione_data) >
                new Date()) {
                vaccininew.value.vaccinazione_data = new Date().toISOString().split('T')[0];
                errors.value[1] = 'La data inserita non è valida!';
                return;
            }
            errors.value[1] = '';
        }
        function closeModal() {
            store.fetchVaccini();
            showConfirm.value = false;
            if (!resolvePromise)
                return;
            resolvePromise(false);
            emit("cancel");
        }
        __expose({ openModal: openModal });
        return function (_ctx, _cache) {
            return (showConfirm.value)
                ? (_openBlock(), _createBlock(_unref(Modal), {
                    key: 0,
                    size: "3xl",
                    onClose: closeModal
                }, {
                    header: _withCtx(function () { return [
                        _createVNode(AlertModal, {
                            ref_key: "alertModal",
                            ref: alertModal
                        }, null, 512),
                        _createVNode(vaccinazioniModalHeader, {
                            title: _ctx.$t(_unref(pazienteModalTitle))
                        }, null, 8, ["title"])
                    ]; }),
                    body: _withCtx(function () { return [
                        _createElementVNode("section", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("form", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("Vaccinazione")), 1),
                                            _withDirectives(_createElementVNode("div", _hoisted_7, [
                                                (_openBlock(), _createElementBlock("svg", {
                                                    "aria-hidden": !_unref(farmacoSrc),
                                                    class: "w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
                                                    viewBox: "0 0 100 101",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg"
                                                }, _hoisted_11, 8, _hoisted_8)),
                                                _hoisted_12
                                            ], 512), [
                                                [_vShow, _unref(farmacoSrc)]
                                            ]),
                                            _createElementVNode("div", _hoisted_13, [
                                                _hoisted_14,
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    id: "vaccinazione",
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (_isRef(vacciniSearch) ? (vacciniSearch).value = $event : vacciniSearch = $event); }),
                                                    onKeyup: filtername,
                                                    onClick: _cache[1] || (_cache[1] = function ($event) { return (_isRef(isOpen) //@ts-ignore
                                                        ? isOpen.value = true : isOpen = true); }),
                                                    class: _normalizeClass([{ 'border-red-500': _unref(errors)[0] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
                                                    placeholder: !_unref(vaccininew).vaccinidetails['descrizione_breve'] ? _ctx.$t('Cerca vaccinazioni') : _unref(vaccininew).vaccinidetails['descrizione_breve']
                                                }, null, 42, _hoisted_15), [
                                                    [_vModelText, _unref(vacciniSearch)]
                                                ])
                                            ]),
                                            _withDirectives(_createElementVNode("select", {
                                                id: "vaccinazione",
                                                onChange: _cache[2] || (_cache[2] = function ($event) { return (onVaccineChange($event)); }),
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((_unref(vaccininew).id_vaccino) = $event); }),
                                                size: "10",
                                                class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredVaccinisReact.Farmaci, function (item) {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        selected: item.id_farmaco_codifa ===
                                                            __spreadArray([], filteredVaccinisReact.Farmaci, true)[0].id_farmaco_codifa,
                                                        key: item.id_farmaco_codifa,
                                                        value: item.id_farmaco_codifa
                                                    }, _toDisplayString(item === null || item === void 0 ? void 0 : item.descrizione_breve), 9, _hoisted_16));
                                                }), 128))
                                            ], 544), [
                                                [_vShow, _unref(isOpen) === true],
                                                [_vModelSelect, _unref(vaccininew).id_vaccino]
                                            ]),
                                            _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(errors)[0]), 1)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("Data *")), 1),
                                        _withDirectives(_createElementVNode("input", {
                                            class: _normalizeClass([{ 'border-red-500': _unref(errors)[1] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"]),
                                            onChange: validateDate,
                                            type: "date",
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((_unref(vaccininew).vaccinazione_data) = $event); })
                                        }, null, 34), [
                                            [_vModelText, _unref(vaccininew).vaccinazione_data]
                                        ]),
                                        _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(errors)[1]), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("Reazioni *")), 1),
                                        _withDirectives(_createElementVNode("input", {
                                            class: _normalizeClass([{ 'border-red-500': _unref(errors)[2] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"]),
                                            type: "text",
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((_unref(vaccininew).vaccinazione_reazioni) = $event); })
                                        }, null, 2), [
                                            [_vModelText,
                                                _unref(vaccininew).vaccinazione_reazioni
                                            ]
                                        ]),
                                        _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(errors)[2]), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("Richiamo *")), 1),
                                        _withDirectives(_createElementVNode("select", {
                                            class: _normalizeClass([{ 'border-red-500': _unref(errors)[3] }, "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"]),
                                            id: "richiamo",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((_unref(vaccininew).vaccinazione_richiamo) = $event); }),
                                            name: "rich"
                                        }, _hoisted_29, 2), [
                                            [_vModelSelect,
                                                _unref(vaccininew).vaccinazione_richiamo
                                            ]
                                        ]),
                                        _createElementVNode("p", _hoisted_30, _toDisplayString(_unref(errors)[3]), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_31, [
                                        (_unref(vaccininew).id_vaccinazione == 0)
                                            ? (_openBlock(), _createElementBlock("label", _hoisted_32, _toDisplayString(_ctx.$t(" Livello di confidenzialità * ")), 1))
                                            : _createCommentVNode("", true),
                                        (_unref(vaccininew).id_vaccinazione == 0)
                                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                key: 1,
                                                class: _normalizeClass([{ 'border-red-500': _unref(errors)[4] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
                                                id: "confidenzialità",
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((_unref(vaccininew).id_livello_confidenzialita) = $event); })
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).liveli_confidencialita, function (item, key) {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: item.id_livello_confidenzialita,
                                                        key: key
                                                    }, _toDisplayString(item.confidenzialita_descrizione), 9, _hoisted_33));
                                                }), 128))
                                            ], 2)), [
                                                [_vModelSelect,
                                                    _unref(vaccininew).id_livello_confidenzialita
                                                ]
                                            ])
                                            : _createCommentVNode("", true),
                                        _createElementVNode("p", _hoisted_34, _toDisplayString(_unref(errors)[4]), 1)
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("button", {
                                onClick: _cache[8] || (_cache[8] = function ($event) { return (closeModal()); }),
                                type: "button",
                                class: "mt-4 text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                            }, _toDisplayString(_ctx.$t("Annulla")), 1),
                            _createElementVNode("button", {
                                onClick: saveVaccini,
                                type: "button",
                                class: "mt-4 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            }, _toDisplayString(_ctx.$t("concludi vaccinazione")), 1)
                        ])
                    ]; }),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
